import { createFileRoute } from '@tanstack/react-router'
import { TemplateCatalog } from '@/components/settings-route/other/template-catalog/index.jsx'

export const Route = createFileRoute(
  '/_auth/settings/others/template-catalogs',
)({
  component: TemplateCatalog,
})
